import React, { forwardRef, Ref } from "react"
import styles from "./Section.module.css"
import { SectionProps } from "./types"

const Section = forwardRef<HTMLDivElement, SectionProps>(
    ({ id, img, title, label, style }, ref: Ref<HTMLDivElement>) => {
        return (
            <div id={id} className={styles.lpSection} ref={ref} style={style}>
                <div className={styles.sectionContent}>
                    {img && (
                        <img
                            src={img}
                            alt={title}
                            className={styles.sectionImage}
                            data-view-label={label}
                        />
                    )}
                </div>
            </div>
        )
    }
)

export default Section
